function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// lightbox cast
	const edition_cast = document.querySelector("#_edition_cast");
	if (edition_cast) {
		edition_cast.addEventListener("click", (event) => {
			event.preventDefault();
			const target = event.currentTarget;
			fetch(`/misc/cast/${target.dataset.ct}/${target.dataset.id}/`, {
				headers: {
					"X-Requested-With": "XMLHttpRequest",
				},
				cache: "no-cache",
			})
				.then((response) => {
					if (response.status === 200) {
						return response.text();
					}
					console.warn(" --- Error: ", response.statusText);
				})
				.then((data) => {
					if (data) {
						import("basiclightbox").then((basicLightbox) => {
							const castLightbox = basicLightbox.create(data);
							castLightbox.show();
						});
					}
				})
				.catch((error) => {
					console.warn(error);
				});
		});
	}
});
